(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["visitor-counter"] && !Shopify.designMode) return;
  try {
    (() => {
    const nodes = document.querySelectorAll('.visitor-counter[data-template]');

    nodes.forEach((node) => {
      const textNode = node.querySelector('.visitor-counter__text');
      if (!textNode) return;

      const min = Number(node.dataset.min || 20);
      const maxRaw = Number(node.dataset.max || 30);
      const max = maxRaw < min ? min : maxRaw;
      const template =
        node.dataset.template ||
        '{count_number} people are viewing this right now';
      const intervalSeconds = Math.max(
        1,
        Number(node.dataset.intervalSeconds || 10)
      );

      const update = () => {
        const next = Math.floor(Math.random() * (max - min + 1)) + min;
        textNode.textContent = template.replace('{count_number}', String(next));
      };

      update();
      window.setInterval(update, intervalSeconds * 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
